// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__1E10g","fileBtn":"File_fileBtn__cmMGW","closeBtn":"File_closeBtn__N_8d9","fileSelected":"File_fileSelected__3_aRG","disabled":"File_disabled__3DJOH"};